import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import Tooltip from 'react-tooltip-lite';

import useIsMobile from '../../../hooks/useIsMobile';

import {
  SHARED_TOOLTIP_DISTANCE,
  DESKTOP_TOOLTIP_DISTANCE,
} from '../../../constants/breakpoints';

const iconSvg = type => {
  switch (type) {
    case 'floorplan':
      return 'floorplans.svg';
    case 'room-capacity':
      return 'room-capacity.svg';
    case 'capacity':
      return 'capacity.svg';
    case 'favourite-off':
      return 'favourite-off.svg';
    case 'favourite-on':
      return 'favourite-on.svg';
    default:
      return null;
  }
};

const FeatureIcon = ({
  type,
  name,
  additionalText,
  icon,
  iconAltText,
  displaySvgIcon,
}) => {
  const nameType = () => {
    return name.toLowerCase().replace(/ /g, '-');
  };

  const featureIconClasses = classNames({
    'feature-icon': true,
    [`feature-icon--${type || nameType()}`]: true,
  });

  const isMobileView = useIsMobile();

  return (
    <span className={featureIconClasses}>
      {displaySvgIcon && (
        <Tooltip
          content={iconAltText || name}
          distance={
            isMobileView ? SHARED_TOOLTIP_DISTANCE : DESKTOP_TOOLTIP_DISTANCE
          }
        >
          <ReactSVG
            className="feature-icon__svg"
            src={`/images/icons/bookings/${iconSvg(type)}`}
            data-testid={type}
          />
        </Tooltip>
      )}
      {icon && (
        <Tooltip
          content={iconAltText || name}
          distance={
            isMobileView ? SHARED_TOOLTIP_DISTANCE : DESKTOP_TOOLTIP_DISTANCE
          }
        >
          <img
            className="feature-icon__img"
            src={icon}
            alt={iconAltText || name}
            data-testid={nameType()}
          />
        </Tooltip>
      )}
      <span className="feature-icon__name">{name}</span>
      {additionalText && (
        <span className="feature-icon__additional-text">{additionalText}</span>
      )}
    </span>
  );
};

FeatureIcon.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  additionalText: PropTypes.string,
  icon: PropTypes.string,
  iconAltText: PropTypes.string,
  displaySvgIcon: PropTypes.bool,
};

export default FeatureIcon;
